import { Stack } from '@/theme/index';
import {
  FraudGauge,
  BorderedStack,
  ThreatItem,
  SectionTitle,
  VerticalDivider,
} from '../components';
import { getThreatLevel } from '../utils';

export interface FraudEmailOverviewProps {
  fraudScore?: number | null;
  isValid?: boolean;
  isSuspect?: boolean;
}

export function FraudEmailOverview({
  fraudScore,
  isValid,
  isSuspect,
}: FraudEmailOverviewProps) {
  return (
    <Stack>
      <SectionTitle>Overview</SectionTitle>
      <Stack gap={1} direction={{ md: 'column', lg: 'row' }}>
        <FraudGauge
          fraudScore={fraudScore}
          tooltipText="Indicates the overall FraudScan Score of the user based on the email’s reputation and recent behavior across data sources. FraudScan Scores over 75 should be considered suspicious but not necessarily fraudulent."
        />
        <BorderedStack
          direction="row"
          alignItems="center"
          width="100%"
          height={{ xs: '95px', md: '118px' }}
        >
          <ThreatItem
            text={isValid ? 'Valid' : 'Invalid'}
            tooltipText="Indicates whether the email address appears valid and legitimate."
            threatLevel={getThreatLevel(
              isValid === undefined ? undefined : !isValid
            )}
            width={isSuspect ? '50%' : '100%'}
          />
          {isSuspect && (
            <>
              <VerticalDivider />
              <ThreatItem
                text="Unable to Verify"
                tooltipText="Indicates that the legitimacy of the email address could not be verified and any valid status associated with it may be tainted. Verification may fail if the mail server is currently replying with a temporary error or if the email is used as a “catch all” address."
                threatLevel={getThreatLevel(isSuspect)}
                width={isSuspect ? '50%' : '100%'}
              />
            </>
          )}
        </BorderedStack>
      </Stack>
    </Stack>
  );
}
